export const categories = [
  {
    id: 'xiangchu-zhidao',
    slug: 'xiangchu-zhidao',
    name: '小姨子相处之道',
    description: '探讨年轻小姨子与家庭成员建立良好关系的实用方法与技巧，帮助双方找到舒适的相处模式。',
    icon: 'ri-heart-line',
    articleCount: 4,
  },
  {
    id: 'qinggan-bianjie',
    slug: 'qinggan-bianjie',
    name: '家庭情感边界',
    description: '深入分析家庭关系中的情感边界理论，帮助每个家庭成员理解并维护健康的情感距离。',
    icon: 'ri-shield-line',
    articleCount: 3,
  },
  {
    id: 'jiefu-xiaoyizi',
    slug: 'jiefu-xiaoyizi',
    name: '姐夫小姨子关系',
    description: '专门针对姐夫与小姨子这一特殊家庭关系，提供平衡、尊重的相处建议与沟通方法。',
    icon: 'ri-user-heart-line',
    articleCount: 3,
  },
  {
    id: 'jiaose-dingwei',
    slug: 'jiaose-dingwei',
    name: '家庭角色定位',
    description: '帮助每个家庭成员明确自身角色，找准定位，减少因角色模糊引发的家庭矛盾。',
    icon: 'ri-user-location-line',
    articleCount: 2,
  },
  {
    id: 'qinqi-guanxi',
    slug: 'qinqi-guanxi',
    name: '亲戚关系处理',
    description: '分享亲戚之间复杂关系的处理智慧，涵盖节日往来、日常沟通和矛盾化解等场景。',
    icon: 'ri-group-line',
    articleCount: 2,
  },
  {
    id: 'hexie-xiangchu',
    slug: 'hexie-xiangchu',
    name: '家庭和谐相处',
    description: '提供日常生活中维护家庭和谐氛围的小技巧，从沟通习惯到行为细节全面覆盖。',
    icon: 'ri-home-heart-line',
    articleCount: 2,
  },
];